import Vue from 'vue'
import * as d3 from 'd3'

Vue.prototype.$d3 = d3
